<template>
  <div class="user-index">
    <!--个人信息-->
    <div class="user-header">
      <div class="user-header-inner">
        <div class="user-info">
          <div class="photo"><image src="" mode="aspectFill"></image></div>
          <div class="info">
            <div class="name">某某某</div>
            <div class="tel d-s-c">
              <p class="f12">ID:123</p>
              <p class="ml20 grade">普通</p>
            </div>
            <!-- <div v-if="code.code_status == 1">{{code.code_desc}}:{{code.user_code}}</div> -->
          </div>
        </div>
        <div class="sign-box d-c-c">
          <p class="icon iconfont icon-libao"></p>
          <p class="ml10">签到有礼</p>
        </div>
      </div>

      <!--我的订单-->
      <div class="my-order">
        <div class="group-hd border-b-e">
          <div class="left"><p class="min-name">我的订单</p></div>
        </div>
        <div class="d-b-c">
          <div class="item">
            <div class="icon-box"
              ><span class="icon iconfont icon-quanbudingdan"></span
            ></div>
            <p>全部订单</p>
          </div>
          <div class="item">
            <div class="icon-box pr">
              <span class="icon iconfont icon-icon"></span>
              <p class="dot d-c-c">1</p>
            </div>
            <p>待付款</p>
          </div>
          <div class="item">
            <div class="icon-box pr">
              <span class="icon iconfont icon-daishouhuo"></span>
              <p class="dot d-c-c">1</p>
            </div>
            <p>待收货</p>
          </div>
          <div class="item">
            <div class="icon-box pr">
              <span class="icon iconfont icon-tuikuan"></span>
              <p class="dot d-c-c">1</p>
            </div>
            <p>退款</p>
          </div>
        </div>
      </div>
    </div>

    <!--我的资产-->
    <div class="my-assets d-b-c">
      <div class="list d-a-c flex-1 mr30">
        <div class="item d-c-c d-c">
          <div class="fb f24">1</div>
          <p class="pt10 f15 gray3">余额</p>
        </div>
        <div class="item d-c-c d-c">
          <div class="fb f24">1</div>
          <p class="pt10 f15 gray3">积分</p>
        </div>
      </div>
    </div>

    <div class="btn-edit-del">
          <div class="btn-del" @click.stop="$parent.$parent.onDeleleItem(index)">删除</div>
        </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },
  props: ["item", "index", "selectedIndex"],
  methods: {},
};
</script>

<style lang="scss" scoped>
@import '../../../../../components/page/static/iconfont2.css';
@import '../../../../../components/page/static/iconfont.css';
.group-hd .left .min-name {
    margin-right: 5px;
    font-size: 15px;
    line-height: 45px;
}
.user-header {
  position: relative;
  background: #e2231a;
}
.user-header .user-header-inner {
  position: relative;
  padding: 15px 15px 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.user-header .user-header-inner::after,
.user-header .user-header-inner::before {
  display: block;
  content: "";
  position: absolute;
  border-radius: 50%;
  z-index: 0;
}
.user-header .user-header-inner::after {
  width: 200px;
  height: 200px;
  right: -50px;
  bottom: -100px;
  background-image: radial-gradient(
    90deg,
    rgba(255, 255, 255, 0.2) 10%,
    rgba(255, 255, 255, 0)
  );
}

.user-header .user-header-inner::before {
  width: 100px;
  height: 100px;
  left: -30px;
  top: -10px;
  background-image: radial-gradient(
    -90deg,
    rgba(255, 255, 255, 0.2) 10%,
    rgba(255, 255, 255, 0)
  );
}

.user-header .user-info {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.user-header .photo,
.user-header .photo image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.user-header .photo {
  border: 2px solid #ffffff;
}

.user-header .info {
  padding-left: 10px;
  box-sizing: border-box;
  overflow: hidden;
  color: #ffffff;
}

.user-header .info .name {
  font-weight: bold;
  font-size: 15px;
}

.user-header .info .tel {
  font-size: 13px;
}

.user-header .info .grade {
  display: block;
  padding: 0 8px;
  height: 20px;
  line-height: 18px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
  color: #ffc670;
}

.user-header .sign-box {
  position: absolute;
  right: 10px;
  padding: 0 5px;
  height: 25px;
  border: 1px solid #ffe300;
  border-radius: 12.5px;
  font-size: 12px;
  color: #ffe300;
  z-index: 10;
}
.user-header .sign-box .iconfont {
  color: #ffe300;
}

.user-header .my-order {
  position: absolute;
  padding: 0 15px;
  height: 120px;
  right: 15px;
  bottom: -75px;
  left: 15px;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
  background: #ffffff;
  z-index: 10;
}
.my-order .item {
  display: flex;
  padding: 10px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 13px;
}

.my-order .icon-box,.my-assets .icon-box {
  width: 30px;
  height: 30px;
}

.my-order .icon-box .iconfont,
.my-assets .icon-box .iconfont {
  font-size: 25px;
  color: #333333;
}

.my-order .icon-box .dot {
  position: absolute;
  top: 0;
  left: 15px;
  height: 15px;
  min-width: 15px;
  padding: 2px;
  border-radius:10px;
  font-size: 10px;
  background: #f00808;
  color: #ffffff;
}

.my-assets {
  margin-top: 90px;
  padding: 15px;
  background: #ffffff;
}

.my-wallet {
  position: relative;
  width: 100px;
  border-left: 1px solid #dddddd;
}

.my-wallet::after {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  border: 4px solid transparent;
  border-left-color: #dddddd;
}

.d-b-c {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/page/tabbar/diy/model/UserInfo.vue